import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import kalendicon3 from "../../../assets/svg/dashboard/kalendicon3.svg";
import calendarMaargIcon from "../../../assets/svg/dashboard/calendarMaargIcon.svg";
import ModalFilter2 from "../../common/modalFilter2/index";
import { getSessionCalendar } from "../Dashboard/StartupDashboard/dependencies/action";

import cohortIcon from "../../../assets/svg/dashboard/Icon_Cohort_White_1.svg";
import MsgIcon from "../../../assets/svg/dashboard/Icon_Message_White.svg";
import logoutIcon from "../../../assets/svg/dashboard/Icon_Logout_White.svg";
import firstSidebarIcon from "../../../assets/svg/dashboard/firstSidebarStartup.svg";
import secondSidebarIcon from "../../../assets/svg/dashboard/secondSidebarStartup.svg";
import thirdSidebarIcon from "../../../assets/svg/dashboard/thirdSidebarStartup.svg";
import KeyboardArrowRightRoundedIcon from "@material-ui/icons/KeyboardArrowRightRounded";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import axios from "axios";
import { COHORT_APPLICATION_LIST } from "../../common/constants/ApplicationUrl";
import { PRODUCTION_MOVE_HIDDEN } from "../../common/constants/actionConstants";
import { types } from "../../common/dependencies/reducer/comingSoonReducer";
import Swal from "sweetalert2";
// import swal from "sweetalert";
import api from "../../common/dependencies/utils/Api";

const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    position: "fixed !important",
    top: 0,
    left: 0,
    height: "100vh",
    transform: "translateY(160px)",
    zIndex: 500,
    [theme.breakpoints.down("md")]: {
      transform: "translateY(80px)",
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    // width: theme.spacing(7) + 1,
    width: "80px",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  drawerPaper: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "calc(100vh - 159px)",
    paddingTop: "20px",
    backgroundColor: "#b499c7",
    overflowY: "scroll !important",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#816aaf",
      borderRadius: theme.shape.borderRadius,
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 80px)",
    },
  },
  selectedListItem: {
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "80%",
      height: "2px",
      backgroundColor: "purple",
    },
  },
}));

const MiniDrawer = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [submenuOpen, setSubmenuOpen] = React.useState(null);
  const [subsubmenuOpen, setSubsubmenuOpen] = React.useState(null);
  const [modalVisibility2, setModalVisibility2] = React.useState();
  const [modalVisibility3, setModalVisibility3] = React.useState();
  const [selectedsubmenu, setSelectedSubmenu] = React.useState();
  const [selectedsubsubmenu, setSelectedSubsubmenu] = React.useState();
  const [selectedmainmenu, setSelectedMainmenu] = React.useState();
  const [selecteddash, setSelecteddash] = React.useState(false);
  const [selectedmyreq, setSelectedmyreq] = React.useState(false);

  const { getSessionCalendar, getCalendar } = props;
  const tooltipArr = [];
  tooltipArr.push("View My Dashboard");
  tooltipArr.push("View My Requests");
  tooltipArr.push("View Mentorships");
  tooltipArr.push("View Cohort");
  tooltipArr.push("View Messages");
  tooltipArr.push("View My Sessions");
  // tooltipArr.push("View Session Recordings");

  let value = localStorage.getItem("SavedLoggedInData");
  let LoginFormData = JSON.parse(value);
  // let newselectmenuname;
  useEffect(() => {
    const params = {
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      sessionStatus: "",
      startDate: "2022-08-01T18:00:00.000Z",
      endDate: "2022-08-31T18:00:00.000Z",
    };

    getSessionCalendar(params);
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
    if (window.innerWidth < 900) {
      setTimeout(() => {
        setOpen(false);
        setSubmenuOpen(null);
        setSubsubmenuOpen(null);
      }, 3000);
    }
  };

  const handleShow2 = () => {
    // setIsModalShown(true);
    setModalVisibility2(true);
  };
  const handleShow3 = () => {
    // setIsModalShown(true);
    setModalVisibility3(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setSubmenuOpen(null);
    setSubsubmenuOpen(null);
  };

  const notToBeShown = [
    // {
    //   title: "Create A Cohort",
    //   menuName: "CohortForm",
    // },

    // {
    //   title: "Cohort Applications",
    //   menuName: "cohortApplicationMentor",
    // },
    {
      title: "Cohort Creation",
      menuName: "MyCreatedCohortDashboard",
    },
    {
      title: "Joined Cohorts",
      menuName: "MyJoinedCohortDashboard",
    },
    {
      title: "Discover Cohorts",
      menuName: "allCohortPrograms",
      // subMenuName: "sessionsCalendar",
    },
    // {
    //   title: "All Cohorts",
    //   menuName: "allCohortPrograms",
    // },
    {
      title: "Sessions Calendar",
      menuName: "cohortSessionsCalendar",
      subMenuName: "sessionsCalendar",
    },
  
    // {
    //   title: "Cohort Programs",
    //   menuName: "cohortProgram",
    // },

    // {
    //   title: "Requests",
    //   // menuName: "myrequests",
    //   submenu: [
    //    JSON.parse(localStorage.getItem("SavedLoggedInData"))?.applicationStatus==="VERIFIED" &&
    //     { title: "Mentor Requests", menuName: "cohortMentors" },
    //     { title: "Startup Requests", menuName: "cohortStartup" },
    //     { title: "My Cohort Requests", menuName: "CohortMentorRequest" },
    //   ],
    // },
    // {
    //   title: "Startup Requests",
    //   menuName: "cohortStartup",
    // },
    // {
    //   title: "Cohort Matchmaking",
    //   menuName: "cohortMatchTable",
    // },
    // {
    //   title: "Cohort Mentorships",
    //   menuName: "cohortAdminMentorships",
    // },
    // {
    //   title: "Cohort Group Session",
    //   menuName: "CohortGroupSession",
    // },
    //  {
    //    title: " Cohort Session List",
    //    menuName: "CohortSessionList",
    // },
    // {
    //   title: "My Cohort Requests",
    //   menuName: "CohortMentorRequest",
    // },
    {
      title: "Sessions List",
      menuName: "cohortInvitation",
    },
  ];
  const toBeShown = [
    {
      title: "Create A Cohort",
      menuName: "CohortForm",
    },

    // {
    //   title: "Cohort Applications",
    //   menuName: "cohortApplicationMentor",
    // },
    {
      title: "My Cohort Dashboard",
      menuName: "MyCohortMentorDashboard",
    },
    {
      title: "Discover Cohorts",
      menuName: "allCohortPrograms",
      // subMenuName: "sessionsCalendar",
    },
    // {
    //   title: "My Cohort Requests",
    //   menuName: "CohortMentorRequest",
    // },
    {
      title: "Sessions List",
      menuName: "cohortInvitation",
    },
  ];

  const [cohortMenu, setCohortMenu] = useState([]);

  const getCohortMenu = async () => {
    let value = localStorage.getItem("SavedLoggedInData");
    // let LoginFormData = JSON.parse(value);
    try {
      const res = await // axios({
      //   url: COHORT_APPLICATION_LIST,
      //   method: "post",
      //   data: {
      //     cohortAdminId: JSON.parse(value)?.id,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     country: null,
      //     state: null,
      //     industry: "",
      //     function: "",
      //     stage: "",
      //     searchField: JSON.parse(value).id,
      //     searchKey: null,
      //     status: "VERIFIED",
      //     pageFilter: {
      //       currentPage: 0,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "date_applied",
      //       sortOrder: "DESC",
      //     },
      //   },
      // });

      api.POST(COHORT_APPLICATION_LIST, {
        cohortAdminId: JSON.parse(value)?.id,
        sortKey: "name",
        sortOrder: "ASC",
        country: null,
        state: null,
        industry: "",
        function: "",
        stage: "",
        searchField: JSON.parse(value).id,
        searchKey: null,
        status: "VERIFIED",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 10,
          sortField: "date_applied",
          sortOrder: "DESC",
        },
      });
      setCohortMenu(notToBeShown);
      // if (res.data?.data?.length > 0) {
      //   if (
      //     JSON.parse(localStorage.getItem("SavedLoggedInData"))
      //       ?.applicationStatus === "VERIFIED"
      //   )
      //     setCohortMenu(notToBeShown);
      // } else {
      //   if (
      //     JSON.parse(localStorage.getItem("SavedLoggedInData"))
      //       ?.applicationStatus === "VERIFIED"
      //   )
      //     setCohortMenu(toBeShown);
      // }
    } catch (err) {}
  };

  useEffect(() => {
    getCohortMenu();
    localStorage.removeItem('cohortWindow')
  }, []);

  useEffect(() => {
    props.getNewMessages();
  }, [open]);

  return (
    <>
      {modalVisibility2 && (
        <ModalFilter2
          modalVisibility={modalVisibility2}
          setModalVisibility={setModalVisibility2}
          // sendToParent={setIsParentData}
          showPurposeOfMentorship={true}
          fromPage={"mentorDashboard"}
          allCalendarData={false}
          showCohortsOnly={false}
        />
      )}
      {modalVisibility3 && (
        <ModalFilter2
          modalVisibility={modalVisibility3}
          setModalVisibility={setModalVisibility3}
          // sendToParent={setIsParentData}
          showPurposeOfMentorship={true}
          fromPage={"mentorDashboard"}
          allCalendarData={false}
          showCohortsOnly={true}
        />
      )}
      <Drawer
        variant="permanent"
        open={true}
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx(classes.drawerPaper, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        onMouseEnter={handleDrawerOpen}
        onMouseLeave={handleDrawerClose}
      >
        <List>
          {[
            // {
            //   title: "Dashboard",
            //   logo: firstSidebarIcon,
            //   menuName: "startupMyRequest",
            // },
            {
              title: "My Dashboard",
              logo: firstSidebarIcon,
              menuName: "adminMenu",
              newmenu: "adminMenu",
            },

            {
              title: "Requests",
              logo: secondSidebarIcon,
              // menuName: "myrequestMenu",

              submenu: JSON.parse(localStorage.getItem("SavedLoggedInData"))
                ?.applicationStatus === "VERIFIED" && [
                { title: "My Request", menuName: "myrequestMenu" },
                { title: "All Startup List", menuName: "startupListMentor" },
              ],
              newmenu: "myrequests",
            },
            // {
            //   title: "My Requests",
            //   logo: secondSidebarIcon,
            //   menuName: "myrequestMenu",
            // },
            {
              title: "Mentorships",
              logo: thirdSidebarIcon,
              // submenu: [
              //   { title: "Session", menuName: "session" },
              //   { title: "SessionMom", menuName: "sessionMom" },
              //   {
              //     title: "Engagement Summary",
              //     menuName: "mentorEngagementSummary",
              //   },
              //   {title: 'Matchlist', menuName: 'mentorMatchList'}
              // ],
              menuName:
                JSON.parse(localStorage.getItem("SavedLoggedInData"))
                  ?.applicationStatus === "VERIFIED"
                  ? "mentorMentorships"
                  : "",
              newmenu:
                JSON.parse(localStorage.getItem("SavedLoggedInData"))
                  ?.applicationStatus === "VERIFIED"
                  ? "mentorMentorships"
                  : "",
            },
            {
              title: "Cohort",
              logo: cohortIcon,
              // menuName: "cohortApplicationMentor",
              submenu: cohortMenu,
              // submenu: ["Submenu1", "Submenu2"],
              newmenu: "cohortMenu",
            },
            {
              title: "Messages",
              logo: MsgIcon,
              menuName:
                JSON.parse(localStorage.getItem("SavedLoggedInData"))
                  ?.applicationStatus === "VERIFIED"
                  ? "mentorMentorMessage"
                  : "",
              newmenu: "mentorMentorMessage",
            },
            {
              title: "My Sessions",
              logo: calendarMaargIcon,
              newmenu: "mySessions",
            },
            // {
            //   title: "Session Recordings",
            //   logo: MsgIcon,
            //   menuName: "sessionRecording",
            //   newmenu: "sessionRecording",
            // },
          ].map((item, index) => {
            // const newselectmenuname = item.newmenu;
            // setSelectedMainmenu(newselectmenuname);
            return (
              <>
                <ListItem
                  button
                  onClick={() => {
                    // newselectmenuname = item.newmenu;
                    setSelectedSubmenu(
                      item.newmenu != "cohortMenu" ||
                        item.newmenu != "myrequests"
                        ? selectedsubmenu
                        : ""
                    );

                    setSelectedSubsubmenu(
                      item.newmenu === "mentorMentorships" ||
                        item.newmenu === "adminMenu" ||
                        item.newmenu === "mentorMentorMessage" ||
                        item.newmenu === "mySessions"
                        ? ""
                        : selectedsubsubmenu
                    );
                    // setSelectedSubmenu(
                    //   item.newmenu === "mentorMentorships" ||
                    //     item.newmenu === "adminMenu" ||
                    //     item.newmenu === "mentorMentorMessage" ||
                    //     item.newmenu === "mySessions"
                    //     ? ""
                    //     : selectedsubmenu
                    // );

                    setSelectedMainmenu(
                      // item.newmenu != "cohortMenu" ? "" : item.newmenu
                      item.newmenu
                    );
                    if (window.innerWidth < 900) handleDrawerOpen();
                    item.menuName && props.setSelectedMenu(item.menuName);
                    if (parseInt(submenuOpen) === index) {
                      setSubmenuOpen(-1);
                    } else {
                      setSubmenuOpen(index);
                    }

                    if (
                      item.title === "My Sessions" &&
                      LoginFormData?.applicationStatus == "VERIFIED"
                    ) {
                      handleShow2();
                    }
                  }}
                  className={
                    props.selectedMenu === item.menuName &&
                    classes.selectedListItem
                  }
                  key={item.title}
                  style={{
                    backgroundColor:
                      selectedmainmenu === item.newmenu ? "#5f50836b" : null,
                  }}
                >
                  <ListItemIcon>
                    <div className="newuserTooltip">
                      <img
                        style={{
                          height: "50px",
                          width: "50px",
                          opacity: item.title === "My Sessions" ? 0.75 : "auto",
                        }}
                        src={item.logo}
                        alt={item.title}
                      />
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{ top: "44px", left: "120px", width: "auto" }}
                      >
                        {tooltipArr[index]}
                      </span>
                    </div>
                  </ListItemIcon>
                  <div className="newuserTooltip">
                    <ListItemText
                      style={{ marginLeft: "20px", color: "#fff" }}
                      primary={item.title}
                    />{" "}
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ top: "40px", left: "80px", width: "auto" }}
                    >
                      {tooltipArr[index]}
                    </span>
                  </div>

                  {item.submenu &&
                    (submenuOpen === index ? (
                      <KeyboardArrowDownRoundedIcon style={{ color: "#fff" }} />
                    ) : (
                      <KeyboardArrowRightRoundedIcon
                        style={{ color: "#fff" }}
                      />
                    ))}
                  {open &&
                    item.menuName === "mentorMentorMessage" &&
                    parseInt(props.newMessages) > 0 && (
                      <div
                        style={{
                          borderRadius: "50%",
                          background: "#816AAF",
                          height: "30px",
                          width: "30px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          transform: "translateY(-50%)",
                          fontFamily: "Montserrat",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "white",
                        }}
                      >
                        {props.newMessages}
                      </div>
                    )}
                </ListItem>
                {item.submenu &&
                  item.submenu.length > 0 &&
                  item.submenu.map((subitem) => (
                    <Collapse
                      in={submenuOpen === index}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List
                        component="div"
                        disablePadding
                        style={{
                          paddingLeft: "40px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                        }}
                      >
                        <ListItem
                          button
                          onClick={() => {
                            subitem.menuName &&
                              subitem.menuName !== "cohortSessionsCalendar" &&
                              props.setSelectedMenu(subitem.menuName);
                            setSelectedSubmenu(subitem.menuName);
                            if (parseInt(subsubmenuOpen) === index) {
                              setSubsubmenuOpen(-1);
                            } else {
                              setSubsubmenuOpen(index);
                            }
                            if (subitem.menuName === "cohortSessionsCalendar") {
                              handleShow3();
                            }
                            // setSelectedSubsubmenu(
                            //   !subitem.newmenu ? selectedsubsubmenu : ""
                            // );
                            // if (
                            //   subitem.menuName === "CohortForm" &&
                            //   props.setSelectedMenu(subitem.menuName)
                            // ) {
                            //   // localStorage.setItem("path", "path");
                            //   history.push({
                            //     pathname: "/dashboard",
                            //     state: {
                            //       fromPage: "cohort-sidebar",
                            //       data: JSON.parse(
                            //         localStorage.getItem("SavedLoggedInData")
                            //       ),
                            //       mode: "create",
                            //     },
                            //   });
                            // }
                          }}
                          style={{
                            backgroundColor:
                              subitem.menuName === selectedsubmenu
                                ? "#8779a86b"
                                : "auto",
                          }}
                        >
                          <ListItemText
                            style={{ color: "#fff" }}
                            primary={subitem.title}
                          />

                          {subitem.submenu &&
                            (subsubmenuOpen === index ? (
                              <KeyboardArrowDownRoundedIcon
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              <KeyboardArrowRightRoundedIcon
                                style={{ color: "#fff" }}
                              />
                            ))}
                        </ListItem>
                        {subitem.submenu &&
                          subitem.submenu.length > 0 &&
                          subitem.submenu.map((subsubitem) => (
                            <Collapse
                              in={subsubmenuOpen === index}
                              timeout="auto"
                              unmountOnExit
                            >
                              <List
                                component="div"
                                disablePadding
                                style={{
                                  paddingLeft: "50px",
                                  backgroundColor: "rgba(255,255,255,0.2)",
                                }}
                              >
                                <ListItem
                                  button
                                  onClick={() => {
                                    subsubitem.menuName &&
                                      props.setSelectedMenu(
                                        subsubitem.menuName
                                      );
                                    setSelectedSubsubmenu(subsubitem.menuName);
                                    // if (
                                    //   subsubitem.menuName === "CohortForm" &&
                                    //   props.setSelectedMenu(subsubitem.menuName)
                                    // ) {
                                    //   // localStorage.setItem("path", "path");
                                    //   history.push({
                                    //     pathname: "/dashboard",
                                    //     state: {
                                    //       fromPage: "cohort-sidebar",
                                    //       data: JSON.parse(
                                    //         localStorage.getItem("SavedLoggedInData")
                                    //       ),
                                    //       mode: "create",
                                    //     },
                                    //   });
                                    // }
                                  }}
                                  style={{
                                    backgroundColor:
                                      subsubitem.menuName === selectedsubsubmenu
                                        ? "#8779a86b"
                                        : "auto",
                                  }}
                                >
                                  <ListItemText
                                    style={{ color: "#fff" }}
                                    primary={subsubitem.title}
                                  />
                                </ListItem>
                              </List>
                            </Collapse>
                          ))}
                      </List>
                    </Collapse>
                  ))}
              </>
            );
          })}
          <ListItem button onClick={() => props.logoutClick()}>
            <ListItemIcon>
              <div className="newuserTooltip">
                <img
                  style={{ height: "40px", width: "40px" }}
                  src={logoutIcon}
                  alt="logout"
                />
                <span
                  className="tooltiptext  tooltip-bottom"
                  style={{ top: "44px", left: "130px", width: "70px" }}
                >
                  Logout
                </span>
              </div>
            </ListItemIcon>
            <div className="newuserTooltip">
              <ListItemText
                style={{ marginLeft: "20px", color: "#fff" }}
                primary={"Logout"}
              />
              <span
                className="tooltiptext  tooltip-bottom"
                style={{ top: "40px", left: "80px", width: "auto" }}
              >
                Logout
              </span>
            </div>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getCalendar: state.StartUpReducer.getSessionCalendar,
  };
};

const comingSoonOpen = () => (dispatch) => {
  dispatch({ type: types.SET_OPEN });
};

export default connect(mapStateToProps, {
  getSessionCalendar,
  comingSoonOpen,
})(withRouter(MiniDrawer));
